import React, { PureComponent } from 'react';
import ReactDOMServer from 'react-dom/server';
import _ from 'lodash';
import { Form, Input, Button, Upload, Icon, Alert } from 'antd';
import { withRedux } from '../../hoc';
import { createMediasApi } from '../../services/medias';
import { createPhotoquotesApi } from '../../services/quote/photoquotes';
import { sendMail } from '../../services/mail';
import { json2table, getServiceUrl } from '../../utils';

const FormItem = Form.Item;
const { TextArea } = Input;

const mapStateToProps = state => {
  return {
    t: _.get(state, 't'),
    languages: _.get(state, 'languages'),
    auth: _.get(state, 'auth')
  };
};

const actions = {};

@Form.create()
@withRedux(mapStateToProps, actions)
export default class QuoteForm extends PureComponent {
  state = {
    uploading: false,
    errorMessage: null
  };
  submit = async values => {
    const { t } = this.props;
    if (this.state.uploading) return false;
    this.setState({ uploading: true, errorMessage: null });
    const uploadPhotosData = await Promise.all(
      _.map(_.get(values, 'photos'), async photo => {
        const uploadResult = await createMediasApi(_.get(photo, 'originFileObj'));
        return _.get(uploadResult, 'data');
      })
    );
    if (_.isEmpty(uploadPhotosData)) {
      this.setState({
        errorMessage: t('Upload failed'),
        uploading: false
      });
      return false;
    }
    const createResult = await createPhotoquotesApi({
      requirements: _.get(values, 'requirements'),
      name: _.get(values, 'name'),
      email: _.get(values, 'email'),
      telephone: _.get(values, 'telephone'),
      photos: _.map(uploadPhotosData, photo => _.get(photo, 'id'))
    });
    if (_.get(createResult, 'status') === 'error') {
      this.setState({ errorMessage: _.get(createResult, 'message'), uploading: false });
      return false;
    }
    const sendMailResult = await sendMail({
      subject: `${t('คุณมีการขอราคาใหม่จาก')} ${_.get(values, 'email')}`,
      html: ReactDOMServer.renderToString(
        <div>
          {_.map(uploadPhotosData, (photo, key) => {
            const full_file_path = `${getServiceUrl()}/${_.get(photo, 'path')}`;
            return (
              <img key={key} src={full_file_path} alt="" width="200" style={{ display: 'block', marginBottom: 10 }} />
            );
          })}
          {json2table({
            data: {
              Requirements: _.get(values, 'requirements'),
              Name: _.get(values, 'name'),
              'E-mail': _.get(values, 'email'),
              Telephone: _.get(values, 'telephone')
            }
          })}
        </div>
      )
    });
    console.log('sendMailResult', sendMailResult);
    this.setState({ uploading: false });
    this.props.form.resetFields();
    this.props.onQuoted();
    return true;
  };
  handleSubmitQuote = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.submit(values);
      }
    });
  };
  normFile = e => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };
  render() {
    const { t } = this.props;
    const { getFieldDecorator } = this.props.form;
    const { uploading, errorMessage } = this.state;
    const uploadProps = {
      multiple: true,
      accept: 'image/*',
      listType: 'picture',
      beforeUpload: file => {
        return false;
      }
    };
    return (
      <React.Fragment>
        {errorMessage && <Alert message={errorMessage} type="warning" showIcon closable />}
        <Form onSubmit={this.handleSubmitQuote} className="quote-form">
          <FormItem colon={false} label={t('Upload Photo')}>
            {getFieldDecorator('photos', {
              valuePropName: 'fileList',
              getValueFromEvent: this.normFile,
              rules: [{ required: true, message: t('Please Upload Photo!') }]
            })(
              <Upload {...uploadProps}>
                <Button type="danger" className="no-shadow">
                  {t('Choose Photo')} <Icon type="upload" />
                </Button>
              </Upload>
            )}
          </FormItem>
          <FormItem colon={false} label={t('Requirements')}>
            {getFieldDecorator('requirements', {
              rules: [{ required: true, message: t('Please input your Requirements!') }]
            })(<TextArea rows={4} />)}
          </FormItem>
          <FormItem colon={false} label={t('Name')}>
            {getFieldDecorator('name', {
              initialValue: _.get(this.props.auth.data, 'fullname'),
              rules: [{ required: true, message: t('Please input your Name!') }]
            })(<Input />)}
          </FormItem>
          <FormItem colon={false} label={t('E-mail')}>
            {getFieldDecorator('email', {
              initialValue: _.get(this.props.auth.data, 'email'),
              rules: [
                {
                  type: 'email',
                  message: t('The input is not valid E-mail!')
                },
                {
                  required: true,
                  message: t('Please input your E-mail!')
                }
              ]
            })(<Input />)}
          </FormItem>
          <FormItem colon={false} label={t('Telephone')}>
            {getFieldDecorator('telephone', {
              initialValue: _.get(this.props.auth.data, 'mobile'),
              rules: [{ required: true, message: t('Please input your Telephone!') }]
            })(<Input />)}
          </FormItem>
          <FormItem style={{ textAlign: 'center' }}>
            <Button type="primary" htmlType="submit" className="quote-form-button" loading={uploading}>
              {t('Get Quote')}
            </Button>
          </FormItem>
        </Form>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/QuoteForm.js